import React, { useState } from 'react';
import './Footer.css';
import PrivacyPolicyPopup from './PrivacyPolicyPopup';

const Footer = () => {
  const [isPrivacyPopupOpen, setIsPrivacyPopupOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-main-content">
            <div className="footer-logo">
              <img src="/logo.png" alt="태봉산업기술(주)" className="footer-logo-image" />
              <div className="footer-company-info">
                <h3 className="footer-company-name">태봉산업기술(주)</h3>
                <p className="footer-company-english">TAIBONG INDUSTRIES INC.</p>
              </div>
            </div>
            
            <div className="footer-center">
              <div className="footer-contact">
                <div className="contact-section">
                  <h4 className="contact-title">본사 및 공장</h4>
                  <div className="contact-info">
                    <p>주소: 인천광역시 남동구 남동로 327 (남동공단 43B-9L)</p>
                    <p>Tel: 032-811-0511</p>
                    <p>Email: saledept@taibong.com</p>
                  </div>
                </div>

                <div className="contact-section">
                  <h4 className="contact-title">남부사무소</h4>
                  <div className="contact-info">
                    <p>주소: 경상북도 포항시 북구 흥해읍 해안로 968, 엔솔 1층</p>
                    <p>Tel: 054-231-0513</p>
                    <p>Email: shlee1@taibong.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <button 
            className="privacy-policy-btn privacy-policy-btn-desktop"
            onClick={() => setIsPrivacyPopupOpen(true)}
          >
            개인정보처리방침
          </button>
          
          <button 
            className="privacy-policy-btn privacy-policy-btn-mobile"
            onClick={() => setIsPrivacyPopupOpen(true)}
          >
            개인정보처리방침
          </button>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            Copyright (c) 2024 TAIBONG INDUSTRIES INC. All Rights Reserved.
          </p>
        </div>
      </div>
      
      <PrivacyPolicyPopup 
        isOpen={isPrivacyPopupOpen}
        onClose={() => setIsPrivacyPopupOpen(false)}
      />
    </footer>
  );
};

export default Footer;
